'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isLoaded = isLoaded;
exports.setToken = setToken;
exports.load = load;
exports.login = login;
exports.logout = logout;

var _Cookies = require('../../helpers/Cookies');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'jai20enmaths-cms/auth/LOAD';
var LOAD_SUCCESS = 'jai20enmaths-cms/auth/LOAD_SUCCESS';
var LOAD_FAIL = 'jai20enmaths-cms/auth/LOAD_FAIL';
var LOGIN = 'jai20enmaths-cms/auth/LOGIN';
var LOGIN_SUCCESS = 'jai20enmaths-cms/auth/LOGIN_SUCCESS';
var LOGIN_FAIL = 'jai20enmaths-cms/auth/LOGIN_FAIL';
var LOGOUT = 'jai20enmaths-cms/auth/LOGOUT';
var SET_TOKEN = 'jai20enmaths-cms/auth/SET_TOKEN';

var initialState = {
  loading: false,
  token: null,
  error: null
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        user: action.result,
        authenticated: true
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error,
        authenticated: false
      });
    case LOGIN:
      return (0, _extends3.default)({}, state, {
        error: null,
        loading: true
      });
    case LOGIN_SUCCESS:
      (0, _Cookies.eraseCookie)('j20_auth');
      (0, _Cookies.createCookie)('j20_auth', action.result.authToken, 0.02);
      return (0, _extends3.default)({}, state, {
        loading: false,
        token: action.result.authToken,
        error: null
      });
    case LOGIN_FAIL:
      return (0, _extends3.default)({}, state, {
        token: null,
        loading: false,
        error: action.error
      });
    case LOGOUT:
      (0, _Cookies.eraseCookie)('j20_auth');
      return (0, _extends3.default)({}, state, {
        loading: false,
        token: null
      });
    case SET_TOKEN:
      return (0, _extends3.default)({}, state, {
        token: action.token
      });
    default:
      return state;
  }
}

function isLoaded(globalState) {
  return globalState.auth && globalState.auth.authenticated;
}

function setToken(token) {
  return {
    type: SET_TOKEN,
    token: token
  };
}

function load() {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get('/account');
    }
  };
}

function login(email, password) {
  return {
    types: [LOGIN, LOGIN_SUCCESS, LOGIN_FAIL],
    promise: function promise(client) {
      return client.post('/account/admin_login', {
        data: {
          email: email,
          password: password
        }
      });
    }
  };
}

function logout() {
  return {
    type: LOGOUT
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/auth.js
// module id = 197
// module chunks = 0